import classNames from 'classnames';
import Head from 'next/head';
import type { ElementType, ReactNode } from 'react';
import { IosDeviceType, getIosDeviceType } from 'src/utils/get-mobile-operating-system';
import ModalContainer from '../modal-container/modal-container';
import styles from './alert.module.scss';
type ModalProps = {
  size?: 'sm' | 'lg' | 'xl';
  fullscreen?: true | string | 'sm-down' | 'md-down' | 'lg-down' | 'xl-down' | 'xxl-down';
  bsPrefix?: string;
  centered?: boolean;
  backdropClassName?: string;
  animation?: boolean;
  dialogClassName?: string;
  contentClassName?: string;
  modalContentClassName?: string;
  mobileFullHeight?: boolean;
  dialogAs?: ElementType;
  scrollable?: boolean;
  [p: string]: any;
};
export type TpAlertProps = ModalProps & {
  canClose?: boolean;
  image?: ReactNode;
  title?: ReactNode;
  description?: ReactNode;
  footer?: ReactNode;
};
const Alert = ({
  ...props
}: TpAlertProps) => {
  const {
    className,
    backdropClassName,
    titleClassName,
    descriptionClassName,
    canClose = true,
    image,
    title,
    description,
    footer,
    children,
    show,
    modalContentClassName,
    ...rest
  } = props;
  const iosDeviceType = getIosDeviceType();
  const isIosHandheld = iosDeviceType === IosDeviceType.IPOD || iosDeviceType === IosDeviceType.IPHONE;
  return <ModalContainer backdropClassName={classNames(styles.backdrop, backdropClassName)} className={classNames(styles.container, className)} canClose={canClose} modalContentClassName={modalContentClassName} show={show} {...rest} data-sentry-element="ModalContainer" data-sentry-component="Alert" data-sentry-source-file="alert.tsx">
      {/*
        Making the status bar on iOS 15 appear to be covered by the backdrop.
        Doing this for iPhones only because iPads and most Android browsers
        have their address bars at the top. Earlier versions of iOS Safari
        do not support `theme-color` and thus are unaffected.
       */}
      {show && isIosHandheld && <Head>
          <meta name="theme-color" content="#B3B3B3" />
        </Head>}
      {image && <div className={styles.imageContainer}>{image}</div>}
      {title && <h2 className={classNames(styles.title, titleClassName)}>{title}</h2>}
      {description && <p className={classNames(styles.description, descriptionClassName)}>
          {description}
        </p>}
      {children}
      {footer}
    </ModalContainer>;
};
export default Alert;